import languages from "./languages";

export const LANGUAGES_AND_SKILLS_NAMESPACE = `users/languagesAndSkills`;

export default languages;
